import defBridge from './apiBridges/default'
import pdfBridge from './apiBridges/pdfBridge'
import productsClientBridge from './apiBridges/productsClient'
import PropTypes from 'prop-types';
import dndBridge from './apiBridges/dndBridge';
import marketsBridge from './apiBridges/markets';

// cписок дескрипторов
const Descriptors = {};

// список бриджей
const apiBridges = {
    defBridge:defBridge,
    pdfBridge:pdfBridge,
    productsClientBridge:productsClientBridge,
    dndBridge:dndBridge,
    marketsBridge:marketsBridge,
  };

// получение дескриптора
export function getDataSource(id){
    const descr = Descriptors[id] ? Descriptors[id] : Descriptors.default;
    const br = apiBridges[descr.api] ? apiBridges[descr.api]() : {};
    return {...br, descr};
}

// регистрация дескриптора
export function registerDescr(descr) {
    Descriptors[descr.id] = descr;
  }

getDataSource.propTypes = {
    id: PropTypes.string,
  };

registerDescr.propTypes = {
    descr: PropTypes.object,
  };